import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

import { useLocalization } from '../contexts/LocalizationContext';
import { useAuth } from '../contexts/AuthContext';

import DescriptionIcon from '@material-ui/icons/Description';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CreateIcon from '@material-ui/icons/Create';
import Euro from '@material-ui/icons/Euro';

import { getBaseRoute } from '../utility';

const NavigationPagemenu = ({ org, ...props }) => {
  const { authLevel, user, selectedTenant, role } = useAuth();

  const { localize } = useLocalization();
  const { pathname } = useLocation();

  const orgName = pathname.split('/')[2];

  if (role === 'student') {
    return (
      <Nav as='ul' className='navbar-nav me-auto d-flex gap-2 mt-lg-0'>
        <Nav.Item as='li'>
          <Nav.Link
            as={NavLink}
            to={`/organization/${orgName}/student/new-application`}>
            <i className={'me-1'}>
              <CreateIcon style={{ fontSize: '1.2rem' }} />
            </i>
            {localize('nav.link.newApplication')}
          </Nav.Link>
        </Nav.Item>

        <Nav.Item as='li'>
          <Nav.Link
            as={NavLink}
            to={`/organization/${orgName}/student/open-application`}>
            <i className={'me-1'}>
              <AutorenewIcon style={{ fontSize: '1.2rem' }} />
            </i>
            {localize('nav.link.openApplication')}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item as='li'>
          <Nav.Link as={NavLink} to={`/organization/${orgName}/student/archive`}>
            <i className={'me-1'}>
              <DescriptionIcon style={{ fontSize: '1.2rem' }} />
            </i>
            {localize('nav.link.student.archive')}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item as='li'>
          <Nav.Link
            as={NavLink}
            to={`/organization/${orgName}/student/payments`}>
            <i className={'me-1'}>
              <Euro style={{ fontSize: '1.2rem' }} />
            </i>
            {localize('nav.link.payments')}
          </Nav.Link>
        </Nav.Item>
      </Nav>
    );
  }

  if (role === 'handler') {
    return (
      <Nav as='ul' className='navbar-nav me-auto d-flex gap-2 mt-lg-0'>
        <Nav.Item as='li'>
          <Nav.Link as={NavLink} to={`/handler/handling`}>
            {localize('nav.link.handling')}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item as='li'>
          <Nav.Link as={NavLink} to={`/handler/handlingHistory`}>
            {localize('nav.link.handling.history')}
          </Nav.Link>
        </Nav.Item>
      </Nav>
    );
  }

  if (role === 'admin' || role === 'maintainer') {
    return (
      <>
        <Nav as='ul' className='navbar-nav me-auto d-flex gap-2 mt-lg-0'>
          <Nav.Item as='li'>
            <Nav.Link
              as={NavLink}
              className='text-nowrap'
              to={getBaseRoute(user, authLevel)}>
              {localize(selectedTenant?.name)}
            </Nav.Link>
          </Nav.Item>

          {role != 'maintainer' && (
            <>
              <Nav.Item as='li'>
                <Nav.Link as={NavLink} to={`/handler/handling`}>
                  {localize('nav.link.handling')}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as='li'>
                <Nav.Link as={NavLink} to={`/handler/handlingHistory`}>
                  {localize('nav.link.handling.history')}
                </Nav.Link>
              </Nav.Item>
            </>
          )}
        </Nav>
      </>
    );
  }

  if (role === 'root') {
    return (
      <Nav as='ul' className='navbar-nav me-auto d-flex gap-2 mt-lg-0'>
        <Nav.Item as='li'>
          <Nav.Link as={NavLink} to={`/admin/organizations`}>
            {localize('nav.link.organizations', { editable: false })}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item as='li'>
          <Nav.Link as={NavLink} to={`/admin/system-messages`}>
            {localize('nav.link.system.messages', { editable: false })}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item as='li'>
          <Nav.Link as={NavLink} to={`/admin/users`}>
            {localize('nav.link.userrights', { editable: false })}
          </Nav.Link>
        </Nav.Item>
      </Nav>
    );
  }

  return <></>;
};

export default NavigationPagemenu;
